import { Button, P, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

import AccordionSection from '../../accordion-section';

const { border, colors, media } = theme;

export const BestSellerTag = styled(P)`
  color: ${colors.white};
`;

export const BestSellerWrapper = styled.div`
  background-color: ${colors.purple};
  padding: 0.5rem 0 0.5rem 1rem;
`;

export const CardWrapper = styled.div<{ index: number | undefined; isBestSeller: boolean | undefined }>`
  border: ${({ isBestSeller }) => (isBestSeller ? `1px solid ${colors.purple}` : `${border.greyBorder}`)};

  @media (min-width: ${media.md}) {
    height: fit-content;
    margin: 0 auto;
    max-width: 21.25rem;
    flex-shrink: 1;
    flex-grow: 1;
    flex-basis: 21.25rem;
  }
`;

export const DetailsWrapper = styled.div<{ isBestSeller: boolean | undefined }>`
  padding: ${({ isBestSeller }) => (isBestSeller ? `1rem` : '2.5rem')} 1rem 2.5rem 1rem;
`;

export const ServiceWrapper = styled.div`
  margin: 1rem 0;

  & > section {
    padding: unset;
  }
`;

export const StyledAccordionSection = styled(AccordionSection)`
  & button > p {
    align-items: flex-start;
    padding-left: 0;
  }

  & button > p > svg {
    margin-left: 1.5rem;
    min-width: 1rem;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 1rem;
  max-width: 154px;
  padding: 1.125rem 1rem;
`;
